<div class="bs-section-header" style="min-height: 3rem">
  <app-warning-banner *ngIf="menuWarningTooltip" class="mb-24px">
    {{ menuWarningTooltip }}
  </app-warning-banner>
  <ng-content></ng-content>
</div>
